import { Col, useTheme } from "@commonlibs";
import useUserState from "ui/adapter/state/useUserState";
import PartnerPointOfSellTable from "ui/partner/components/PartnerPointOfSellTable/PartnerPointOfSellTable";
import usePartnerPointOfSell from "features/partners/hooks/usePartnerPointOfSell";

const PartnerPointOfSell = () => {
    const { selectedRole } = useUserState();
    const { data: pointsOfSell } = usePartnerPointOfSell({ address: selectedRole?.resourceAddress });
    const { spacing } = useTheme();
    // skipcq: JS-0437 
    return (
        <Col gap={spacing[6]}>
            {pointsOfSell?.map((pointOfSell, index) => {
                // skipcq: JS-0437 - no hay id se usa index
                return <PartnerPointOfSellTable key={`pointOfSell_${index}`} data={[pointOfSell]} isLoading={false} />;
            })}
        </Col>
    );
};

export default PartnerPointOfSell;
